import React from "react";
import { CheckboxLabel } from "../modules/DefaultValueField/CheckboxLabel";
import { CUSTOM_COLUMN_DATA_TYPE } from "../../CustomColumn/constants/CustomColumn.constants";

export const CUSTOM_COLUMN_FORM_KEYS = {
  column_name: {
    key: "column_name",
    label: "Column name",
    placeholder: "eg: Status",
  },
  field_type: {
    key: "field_type",
    label: "Field Type",
    placeholder: "Select field type",
  },
  default_value: {
    key: "default_value",
    label: "Default value (optional)",
    placeholder: "Select a field type first",
    tooltipText:
      "This value will be added by default to this field for any customer/lead who's value has not been filled.",
  },
  custom_value: {
    key: "custom_value",
    label: "Custom value",
    placeholder: "Select a field type first",
  },
  older_contacts: {
    key: "older_contacts",
    label: "Selection for older contacts",
  },
  sections: {
    key: "sections",
    label: "Add this new column to",
  },
  options: {
    key: "options",
  },
};

export const COLUMN_FIELD_TYPE_OPTIONS = {
  short_text: {
    value: CUSTOM_COLUMN_DATA_TYPE.SHORT_TEXT,
    label: "Short text (upto 100 characters)",
  },
  paragraph_text: {
    value: CUSTOM_COLUMN_DATA_TYPE.LONG_TEXT,
    label: "Long text (more than 100 characters)",
  },
  single_select: {
    value: CUSTOM_COLUMN_DATA_TYPE.SINGLE_SELECT,
    label: "Single select option",
  },
  multiple_select: {
    value: CUSTOM_COLUMN_DATA_TYPE.MULTIPLE_SELECT,
    label: "Multiple select options",
  },
  date: {
    value: CUSTOM_COLUMN_DATA_TYPE.DATE,
    label: "Date",
  },
  //   date_time: {
  //     value: 6,
  //     label: "Date & time",
  //   },
  time: {
    value: CUSTOM_COLUMN_DATA_TYPE.TIME,
    label: "Time",
  },
  gender: {
    value: CUSTOM_COLUMN_DATA_TYPE.GENDER,
    label: "Gender",
  },
  url: {
    value: CUSTOM_COLUMN_DATA_TYPE.URL,
    label: "URL",
  },
  indian_city: {
    value: CUSTOM_COLUMN_DATA_TYPE.INDIAN_CITY,
    label: "Indian City",
  },
  indian_state: {
    value: CUSTOM_COLUMN_DATA_TYPE.INDIAN_STATE,
    label: "Indian State",
  },
  assignee: {
    value: CUSTOM_COLUMN_DATA_TYPE.PRIMARY_KEY,
    label: "Assignee",
  },
};

export const OLDER_CONTACT_VALUE_OPTIONS = {
  DEFAULT: { value: 1, label: "Fill in the default value" },
  CUSTOM: { value: 2, label: "Add a custom value" },
  EMPTY: { value: 3, label: "Leave empty, I will add manually" },
};

export const TABLE_OPTIONS = {
  LEADS: { value: "webpage_leads", label: "Webpage Leads table" },
  CUSTOMERS: { value: "all_customers", label: "All Customers table" },
};

export const LEAD_TABLE_OPTIONS = {
  LEADS: {
    id: TABLE_OPTIONS.LEADS.value,
    value: TABLE_OPTIONS.LEADS.value,
    disabled: true,
    label: (
      <CheckboxLabel
        label={TABLE_OPTIONS.LEADS.label}
        tooltipText={
          <>
            &apos;Webpage leads&apos; is where you are present right now, it is
            where all your leads get collected. This column will be added here
            by default.
          </>
        }
      />
    ),
  },
  CUSTOMERS: {
    id: TABLE_OPTIONS.CUSTOMERS.value,
    value: TABLE_OPTIONS.CUSTOMERS.value,
    label: (
      <CheckboxLabel
        label={TABLE_OPTIONS.CUSTOMERS.label}
        tooltipText={
          <>
            &apos;All customers&apos; is where all your customers are listed. It
            can be accessed from the left panel.Select if you want to add this
            new column to the &apos;All customers&apos; table as well.
          </>
        }
      />
    ),
  },
};

export const CUSTOMER_TABLE_OPTIONS = {
  CUSTOMERS: {
    id: TABLE_OPTIONS.CUSTOMERS.value,
    value: TABLE_OPTIONS.CUSTOMERS.value,
    disabled: true,
    label: (
      <CheckboxLabel
        label={TABLE_OPTIONS.CUSTOMERS.label}
        tooltipText={
          <>
            &apos;All customers&apos; is where you are present right now, it is
            where all your customers get collected. This column will be added
            here by default.
          </>
        }
      />
    ),
  },
  LEADS: {
    id: TABLE_OPTIONS.LEADS.value,
    value: TABLE_OPTIONS.LEADS.value,
    label: (
      <CheckboxLabel
        label={TABLE_OPTIONS.LEADS.label}
        tooltipText={
          <>
            &apos;Webpage leads&apos; is where all your leads are listed. It can
            be accessed from the left panel.Select if you want to add this new
            column to the &apos;Webpage Leads&apos; table as well.
          </>
        }
      />
    ),
  },
};

export const DETAILS_ACC_ID = "details"; // accordian if for column details
export const SETTINGS_ACC_ID = "settings"; // accordian if for column settings
export const SHORT_TEXT_MAX_LENGTH = 100;
